import Navbar from "../../components/navbar/navbarComponent";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LicenciaFoundComponent from "./search/licenciaFound";
import OpcionesFotoLicencia from "./ingresoLicencia/opcionesFotoLicencia";
import SuccessModal from "../../components/modals/successModal";
import IngresarLicencia from "./ingresoLicencia/ingresarLicencia";
import ConfirmarDatosLicencia from "./ingresoLicencia/confirmarDatos";
import TakeFotoLicencia from "./ingresoLicencia/takeFotoLicencia";
import FilterLicenciasComponent from "./filter/filterLicencias";
import LicenciasCardsComponent from "./cards/licenciasCards";
import LicenciaFinderComponent from "./search/licenciaFinder";
import LicenciasPaginationComponent from "./pagination/licenciasPagination";
import { getLicencias } from "../../redux/actions";

function LicenciasComponent() {
  const dispatch = useDispatch();

  const [refreshLicencias, setRefreshLicencias] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const actualizarLicencias = () => {
    setRefreshLicencias((prev) => prev + 1);
  };

  const fetchLicencias = async (
    page = 1,
    filter = "todas",
    limit = 9
  ) => {
    try {
      setLoading(true);
      setError(false);

      await dispatch(
        getLicencias(page, filter, limit)
      );
    } catch (error) {
      console.error("Error al cargar las licencias:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLicencias();
  }, [refreshLicencias]);

  const [isModalIngresarOpen, setIsModalIngresarOpen] =
    useState(false);

  const openModalIngresar = () =>
    setIsModalIngresarOpen(true);

  const closeModalIngresar = () =>
    setIsModalIngresarOpen(false);

  const [isFotoOpcionesOpen, setIsFotoOpcionesOpen] =
    useState(false);

  const openOpcionesFotoLicencia = () => {
    setIsFotoOpcionesOpen(true);
    closeModalIngresar();
  };

  const closeOpcionesFotoLicencia = () =>
    setIsFotoOpcionesOpen(false);

  const [isTakeFotoOpen, setIsTakeFotoOpen] =
    useState(false);

  const openTakeFotoLicencia = () => {
    setIsTakeFotoOpen(true);
    closeOpcionesFotoLicencia();
  };

  const closeTakeFotoLicencia = () => {
    setIsTakeFotoOpen(false);
    setIsFotoOpcionesOpen(true);
  };

  const [confirmarDatosOpen, setConfirmarDatosOpen] =
    useState(false);

  const openConfirmarDatosLicencia = () => {
    setConfirmarDatosOpen(true);
    setIsTakeFotoOpen(false);
    setIsFotoOpcionesOpen(false);
  };

  const closeConfirmarDatosLicencia = () => {
    setConfirmarDatosOpen(false);
  };

  const [successModalOpen, setSuccessModalOpen] =
    useState(false);

  const openSuccessModal = () =>
    setSuccessModalOpen(true);

  const closeSuccessModal = () => {
    setSuccessModalOpen(false);
    actualizarLicencias();
  };

  return (
    <div className="bg-[#F5FAFF] min-h-screen">
      <Navbar />

      {isModalIngresarOpen && (
        <IngresarLicencia
          closeModalIngresar={closeModalIngresar}
          openOpcionesFotoLicencia={openOpcionesFotoLicencia}
        />
      )}

      {isFotoOpcionesOpen && (
        <OpcionesFotoLicencia
          closeOpcionesFotoLicencia={closeOpcionesFotoLicencia}
          openTakeFotoLicencia={openTakeFotoLicencia}
          openConfirmarDatosLicencia={openConfirmarDatosLicencia}
          openOpcionesFotoLicencia={openOpcionesFotoLicencia}
        />
      )}

      {isTakeFotoOpen && (
        <TakeFotoLicencia
          closeTakeFotoLicencia={closeTakeFotoLicencia}
          openConfirmarDatosLicencia={openConfirmarDatosLicencia}
        />
      )}

      {confirmarDatosOpen && (
        <ConfirmarDatosLicencia
          closeConfirmarDatosLicencia={closeConfirmarDatosLicencia}
          openSuccessModal={openSuccessModal}
        />
      )}

      {successModalOpen && (
        <SuccessModal
          closeSuccessModal={closeSuccessModal}
        />
      )}

      <div className="flex flex-col items-center bg-[#F5FAFF] gap-8">
        <div className="flex flex-col md:flex-row items-center md:items-start bg-[#F5FAFF] gap-4 md:gap-32 pt-[4rem]">
          <div className="flex w-full md:w-auto">
            <button
              onClick={openModalIngresar}
              className="w-full md:w-auto border border-[#0477AD] h-[50px] px-[18px] py-[13px] bg-[#0477ad] rounded-lg justify-center items-center gap-1 flex"
            >
              <div className="text-white font-semibold font-inter">
                Ingresar nueva licencia
              </div>
            </button>
          </div>

          <div className="flex flex-col w-full md:self-start md:w-auto">
            <LicenciaFinderComponent />
          </div>
        </div>

        <LicenciaFoundComponent />

        <FilterLicenciasComponent
          fetchLicencias={fetchLicencias}
        />

        <LicenciasCardsComponent
          loading={loading}
          error={error}
          onLicenciaActualizada={actualizarLicencias}
        />

        <LicenciasPaginationComponent
          fetchLicencias={fetchLicencias}
        />
      </div>
    </div>
  );
}

export default LicenciasComponent;